import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { updateGroup } from '@spectee/graphql/mutations';

const document = gql(updateGroup);

export function useUpdateGroup() {
  return useMutation(document);
}
